import { useContext } from "react";
import { device, isV4Template } from "commons/util/coreUtils";
import styled, { keyframes } from "styled-components";
import { ColorThemeContext } from "containers/theme/colorTheme";
import { DefaultColorTheme } from "theme/colors";
import { LoaderV4 } from "templates/template-v-4/loader";

function Loader(props) {
  const colors = useContext(ColorThemeContext);
  const secondaryColor = colors?.primary || DefaultColorTheme?.primary;

  if (isV4Template()) {
    return <LoaderV4 />;
  }

  return (
    <Wrapper style={props?.wrapperStyle} height={props?.height} width={props?.width}>
      <LoaderContainer>
        <LoaderWrapper secondaryColor={secondaryColor}></LoaderWrapper>
        <LoaderText color={secondaryColor}>Loading...</LoaderText>
      </LoaderContainer>
    </Wrapper>
  );
}

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const prixClipFix = keyframes`
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }
  75%, 100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ height }) => height || "100vh"};
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const LoaderText = styled.div`
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${({ color }) => color || "#150764"};
`;

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => width || "56px"};
  height: ${({ height }) => height || "56px"};
  border-radius: 50%;
  position: relative;
  animation: ${rotate} 1s linear infinite;

  &::before,
  &::after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 5px solid ${({ primaryColor }) => primaryColor || "#f3f4f6"};
    animation: ${prixClipFix} 2s linear infinite;
  }

  &::after {
    transform: rotate3d(90, 90, 0, 180deg);
    border-color: ${({ secondaryColor }) =>
      secondaryColor || DefaultColorTheme?.primary};
  }

  @media ${device.laptop} {
    width: ${({ width }) => width || "72px"};
    height: ${({ height }) => height || "72px"};
  }
`;

export default Loader;
